var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8487 15H20.1513L22.5 28H8.5L10.8487 15Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4134 11.531C25.7934 12.617 26 13.7844 26 15C26 18.4868 24.3004 21.5766 21.6845 23.4863L21.8802 24.5693C24.967 22.5071 27 18.991 27 15C27 13.5554 26.7336 12.1731 26.2474 10.8993C25.9951 11.1401 25.7154 11.3524 25.4134 11.531ZM19.1885 5.16614C19.3737 4.8684 19.592 4.59345 19.8384 4.34645C18.4996 3.80072 17.0349 3.5 15.5 3.5C9.14873 3.5 4 8.64873 4 15C4 18.991 6.03297 22.5071 9.11982 24.5693L9.31548 23.4863C6.69957 21.5766 5 18.4868 5 15C5 9.20101 9.70101 4.5 15.5 4.5C16.798 4.5 18.0409 4.73551 19.1885 5.16614Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0833 12.1667C25.6146 12.1667 27.6667 10.1146 27.6667 7.58333C27.6667 5.05203 25.6146 3 23.0833 3C20.552 3 18.5 5.05203 18.5 7.58333C18.5 10.1146 20.552 12.1667 23.0833 12.1667Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5333 8.13872C17.6059 7.72809 16.5796 7.5 15.5 7.5C11.3579 7.5 8 10.8579 8 15C8 16.9368 8.73417 18.7022 9.93939 20.0329L10.1751 18.7286C9.43459 17.673 9 16.3873 9 15C9 11.4101 11.9101 8.5 15.5 8.5C16.7465 8.5 17.911 8.85086 18.9002 9.4592C18.7154 9.04767 18.5895 8.60393 18.5333 8.13872ZM22.4271 12.12C21.9638 12.0536 21.5229 11.9179 21.1151 11.7237C21.6776 12.6857 22 13.8052 22 15C22 16.3873 21.5654 17.673 20.8249 18.7286L21.0606 20.0329C22.2658 18.7022 23 16.9368 23 15C23 13.9796 22.7962 13.0068 22.4271 12.12Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.792 8.04183L22.167 9.41683L25.3753 6.2085",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevStatus);
export default __webpack_public_path__ + "static/media/dev_status.6af950320b7e80883de98e9d7aabeace.svg";
export { ForwardRef as ReactComponent };